// Module
var code = "<h1 id=\"release-notes-291\">Release notes 2.9.1</h1> <p>Date : 12/05/2021</p> <h4 id=\"améliorations\">Améliorations</h4> <ul> <li>Les magasins affichés ne seront que les magasins &quot;actifs&quot;.</li> </ul> ";
// Exports
export default code;